export type Hit = {
  messageId: string;
  indexInMessage: number;
  start: number;
  length: number;
};

function normalizeUnit(ch: string): string {
  const decomposed = ch.normalize("NFD");
  let out = "";
  for (let i = 0; i < decomposed.length; i++) {
    const code = decomposed.charCodeAt(i);
    if (code >= 0x0300 && code <= 0x036f) continue;
    out += decomposed[i];
  }
  const lower = out.toLowerCase();
  let result = lower;
  if (lower.length !== 1) {
    // Normalises to nothing or more than one unit: keep first unit of NFD
    // form lower-cased, falling back to the original unit.
    result = decomposed.length > 0 ? decomposed[0].toLowerCase() : ch;
    if (result.length !== 1) result = ch;
  }
  if (result === "đ" || result === "Đ") result = "d";
  return result.length === 1 ? result : result.slice(0, 1);
}

export function normalizeText(s: string): string {
  let out = "";
  for (let i = 0; i < s.length; i++) {
    out += normalizeUnit(s[i]);
  }
  return out;
}

const MAX_QUERY = 200;

function prepareQuery(q: string): string {
  return normalizeText(q.trim().slice(0, MAX_QUERY));
}

function matchSegments(text: string, q: string): { start: number; length: number }[] {
  if (q.length < 2) return [];
  const hay = normalizeText(text);
  const result: { start: number; length: number }[] = [];
  let idx = hay.indexOf(q, 0);
  while (idx !== -1) {
    result.push({ start: idx, length: q.length });
    idx = hay.indexOf(q, idx + q.length);
  }
  return result;
}

export function findHits(
  messages: { id: string; text: string }[],
  query: string
): Hit[] {
  const hits: Hit[] = [];
  const q = prepareQuery(query);
  if (q.length < 2) return hits;
  for (const message of messages) {
    const matches = matchSegments(message.text, q);
    matches.forEach((m, indexInMessage) => {
      hits.push({
        messageId: message.id,
        indexInMessage,
        start: m.start,
        length: m.length,
      });
    });
  }
  return hits;
}

export function splitByQuery(
  text: string,
  query: string
): { text: string; hit: boolean }[] {
  const matches = matchSegments(text, prepareQuery(query));
  if (matches.length === 0) return [{ text, hit: false }];
  const segments: { text: string; hit: boolean }[] = [];
  let pos = 0;
  for (const m of matches) {
    if (m.start > pos) {
      segments.push({ text: text.slice(pos, m.start), hit: false });
    }
    segments.push({ text: text.slice(m.start, m.start + m.length), hit: true });
    pos = m.start + m.length;
  }
  if (pos < text.length) {
    segments.push({ text: text.slice(pos), hit: false });
  }
  return segments;
}
